<template>
  <div class="bar-box">
    <div class="bar-box-title">影像中心TOP10</div>
    <div class="tabs">
      <span
        class="item"
        v-for="tab in tabs"
        :key="tab.value"
        :class="{ active: tab.value === activeTab }"
        @click="handleTabClick(tab.value)"
        >{{ tab.name }}</span
      >
    </div>
    <div class="data-list">
      <div
        class="data-list-item"
        v-for="item in getOrderedData()"
        :key="item.name"
      >
        <div class="title">{{ item.name.slice(0, 7) }}</div>
        <div class="value">
          <span>{{ getProgressValue(item) }}</span>
          <div class="progress-bar">
            <div
              class="progress-bar-inner"
              :style="getProgressStyle(item)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import lodash from "lodash";
// 这里可以引入 props 或后续逻辑
const tabs = [
  {
    name: "检查数量",
    value: "check_count",
  },
  {
    name: "申请单规范率",
    value: "apply_rate",
  },
  {
    name: "初写报告规范率",
    value: "write_rate",
  },
  {
    name: "审核报告规范率",
    value: "audit_rate",
  },
  {
    name: "图像质量合格率",
    value: "image_quality_rate",
  },
];
const activeTab = ref("check_count");
const handleTabClick = (value) => {
  activeTab.value = value;
};
const generateHospitalData = () => {
  const cities = [
    "北京",
    "上海",
    "广州",
    "深圳",
    "杭州",
    "南京",
    "武汉",
    "成都",
    "重庆",
    "西安",
  ];
  const suffixes = [
    "人民医院",
    "中心医院",
    "附属医院",
    "中西医结合医院",
    "妇幼保健院",
  ];
  const rates = () => +(Math.random() * 5 + 95).toFixed(2); // 生成 95.00-99.99 的随机比率

  return Array.from({ length: 50 }, (_, i) => {
    const city = cities[Math.floor(Math.random() * cities.length)];
    const total = Math.floor(Math.random() * 900) + 100; // 100-1000 的随机总数

    return {
      name: `${city}${i % 2 ? "市" : ""}${
        Math.random() > 0.5
          ? `第${["一", "二", "三", "四", "五"][i % 5]}医院`
          : suffixes[i % suffixes.length]
      }`,
      total: total,
      check_count: total - Math.floor(Math.random() * 20), // 允许少量未检查
      apply_rate: rates(),
      write_rate: rates(),
      audit_rate: rates(),
      image_quality_rate: rates(),
    };
  });
};
const dataList = generateHospitalData();
// const dataList = [
//   {
//     name: "河北二院",
//     total: 100,
//     check_count: 100,
//     apply_rate: 98.62,
//     write_rate: 93.62,
//     audit_rate: 97.64,
//     image_quality_rate: 98.62,
//   },
//   {
//     name: "河北三院",
//     total: 200,
//     check_count: 200,
//     apply_rate: 98.62,
//     write_rate: 98.62,
//     audit_rate: 98.62,
//     image_quality_rate: 98.62,
//   },
//   {
//     name: "济南人民医院",
//     total: 300,
//     check_count: 300,
//     apply_rate: 98.62,
//     write_rate: 98.62,
//     audit_rate: 98.62,
//     image_quality_rate: 98.62,
//   },
//   {
//     name: "济南市二院",
//     total: 300,
//     check_count: 300,
//     apply_rate: 98.62,
//     write_rate: 98.62,
//     audit_rate: 98.62,
//     image_quality_rate: 98.62,
//   },
//   {
//     name: "济南市三院",
//     total: 300,
//     check_count: 300,
//     apply_rate: 98.62,
//     write_rate: 98.62,
//     audit_rate: 98.62,
//     image_quality_rate: 98.62,
//   },
//   {
//     name: "济南市四院",
//     total: 300,
//     check_count: 300,
//     apply_rate: 98.62,
//     write_rate: 98.62,
//     audit_rate: 98.62,
//     image_quality_rate: 98.62,
//   },
//   {
//     name: "济南市五院",
//     total: 300,
//     check_count: 300,
//     apply_rate: 98.62,
//     write_rate: 98.62,
//     audit_rate: 98.62,
//     image_quality_rate: 98.62,
//   },
//   {
//     name: "济南市六院",
//     total: 300,
//     check_count: 300,
//     apply_rate: 98.62,
//     write_rate: 98.62,
//     audit_rate: 98.62,
//     image_quality_rate: 98.62,
//   },
//   {
//     name: "济南市七院",
//     total: 300,
//     check_count: 300,
//     apply_rate: 98.62,
//     write_rate: 98.62,
//     audit_rate: 98.62,
//     image_quality_rate: 98.62,
//   },
//   {
//     name: "济南市八院",
//     total: 300,
//     check_count: 300,
//     apply_rate: 98.62,
//     write_rate: 98.62,
//     audit_rate: 98.62,
//     image_quality_rate: 98.62,
//   },
// ];
const getProgressStyle = (item) => {
  if (activeTab.value === "check_count") {
    const max = lodash.maxBy(dataList, "check_count").check_count;
    const value = item.check_count;
    return {
      width: `${(value / max) * 100}%`,
    };
  } else {
    const value = item[activeTab.value];
    return {
      width: `${value}%`,
    };
  }
};
const getProgressValue = (item) => {
  if (activeTab.value === "check_count") {
    // const max = lodash.maxBy(dataList, "check_count").check_count;
    const value = item.check_count;
    return value;
  } else {
    const value = item[activeTab.value] + "%";
    return value;
  }
};
const getOrderedData = () => {
  return lodash.orderBy(dataList, activeTab.value, "desc").slice(0, 10);
};
</script>
<style scoped lang="less">
@import "@/assets/css/global.less";
.bar-box {
  background: @card-background-color;
  border-radius: 8px;
  color: @text-color-secondary;
  padding: 16px;
  font-size: 16px;
  min-height: 120px;
  text-align: left;
  .bar-box-title {
    font-size: 18px;
  }
  .tabs {
    display: flex;
    font-size: 12px;
    background-color: @card-border-color;
    border-radius: 5px;
    padding: 5px;
    margin: 10px 0;
    .item {
      text-align: center;
      cursor: pointer;
      margin-right: 10px;
      display: inline-block;
      height: 20px;
      line-height: 20px;
      border-bottom: 1px solid transparent;
    }
    .item:hover,
    .item.active {
      color: @text-color;
      border-bottom: 1px solid @text-color-secondary;
    }
  }
  .data-list {
    .data-list-item {
      display: flex;
      flex-direction: row;
      gap: 10px;
      line-height: 35px;
      .title {
        flex: 0 0 100px;
        text-align: right;
        font-size: 14px;
      }
      .value {
        flex: 1;
        text-align: left;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        position: relative;
        span {
          position: absolute;
          left: 10px;
          top: 0;
          font-size: 16px;
          color: @text-color;
        }
        .progress-bar {
          width: 100%;
          height: 28px;
          .progress-bar-inner {
            height: 100%;
            background-color: @card-border-color;
            border-radius: 10px;
            transition: width 0.3s;
            display: block;
          }
        }
      }
    }
  }
}
</style>
